export type FontSizesTypes =
  | "indicator"
  | "title"
  | "subtitle"
  | "header"
  | "text"
  | "note";

export interface FontSizes {
  indicator: number;
  title: number;
  subtitle: number;
  header: number;
  text: number;
  note: number;
}

export const isFontSizeType = (value: any): boolean => {
  if (
    value === "indicator" ||
    value === "title" ||
    value === "subtitle" ||
    value === "text" ||
    value === "note"
  ) {
    return true;
  } else {
    return false;
  }
};
